$(document).ready(function () {
  
  var e = $(".content-wrapper"),
    r = 60;


  $('.article-slick').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    nextArrow: '<div class="slick-button-next" aria-label="Next">' + window.assets.icon_right + '</div>',
    prevArrow: '<div class="slick-button-prev" aria-label="Previous">' + window.assets.icon_left + '</div>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

   function TotalLength(el){

    var path = document.querySelectorAll(el);
    if($(el).length > 0){
      for (let elem of path) {
        if(elem.getAttribute("stroke-dasharray")){
          var len = Math.round(elem.getTotalLength() );
          elem.setAttribute("stroke-dasharray", len);
          elem.setAttribute("stroke-dashoffset", len);
          elem.classList.add('draw');
        }
      }
    }
  };
     var header_banner = $('.header-banner.with-animation');
    if(header_banner){
      header_banner.find('.z-top__header').css('opacity','1');
      TotalLength('#actuator-with-usp #Oval');
      TotalLength('#actuator-with-usp #Path');
      setTimeout(function() {
        header_banner.find('.z-top__text').css('opacity','1');
        header_banner.find('.header-content-icons-block svg').css('opacity','1');
        header_banner.find('.header-content-icons-block img').css('opacity','1');
        header_banner.find('#logo_actuators_landing').css('opacity','1');
        TotalLength('#actuator-icon-collection path');
        TotalLength('#actuator-icon-collection #Oval');
        TotalLength('#actuator-icon-collection #Path');
      }, 1000);
      setTimeout(function() {
        header_banner.find('.btn').css('opacity','1');
        header_banner.find('.swiper-container').css('opacity','1');
        header_banner.find('.brands-slide').css('opacity','1');
        TotalLength('#actuator-icon path');
        TotalLength('#actuator-icon #Oval');
        TotalLength('#product_icon #Path');
        TotalLength('#product_icon #Oval');
        header_banner.find('.header-content-icons-title').css('opacity','1');
        header_banner.find('.header-svg circle').css('opacity','1');
        header_banner.find('#actuator-with-usp .path-fill').addClass('full');
        header_banner.find('#actuator-with-usp .path-fill-dark').addClass('full');
      }, 2000);
      setTimeout(function() {
        header_banner.find('#actuator-icon .path-fill').addClass('full');
        header_banner.find('#product_icon .path-fill').addClass('full');
        header_banner.find('#product_icon .path-fill-dark').addClass('full');
        header_banner.find('#actuator-with-usp .path-fill-white').addClass('full');
      }, 2600);
    }


   $('body').on('click', '.product-compare-btn', function (e) {
    e.preventDefault();
    if(getCookie("compare_product_ids")) {
      var compare_product_ids = getCookie("compare_product_ids");
      var array_id = compare_product_ids.split("|");
      console.log(array_id)
      var productId;
      $('.products .col-item').each(function() {
        var count = 0;
        productId = $(this).data('product-id');
          array_id.forEach(function(id) {
            if(productId != id){
              console.log('cookie');
              count ++;
            }
          });
          if(count == array_id.length ){
            compare_product_ids +=  '|' + productId;
          }
      });
      setCookie("compare_product_ids",compare_product_ids,0.020);
    }else{

        var count = 0;
    var ids = "";
    $('.products .col-item').each(function() {
      count++;
      if(count == 1) {
        ids += $(this).data('product-id');
      }
      else {
        ids += '|' + $(this).data('product-id');
      }
    });
    setCookie("compare_product_ids",ids,0.020);
    }

    document.location.href = '/pages/product-compare';
  });

    function o() {
    $(".pos").offset().top - 0 <= $(this).scrollTop() ?
      (
        $(".tabs-wrapper .tabs").addClass("tabs-sticky")
      )
      :
      (
        $(".tabs-wrapper .tabs").removeClass("tabs-sticky")
      )
  }

  o();

    function a() {
    $(window).width() <= 768 && (e.css({
      paddingTop: 0
    }), $(".tabs-wrapper .tabs").removeClass("tabs-sticky"))
  }

  a();

  $(window).on("scroll", function () {
    o(), a()
  });

  $(window).resize(function () {
    o(), a()
  });

  $(".tabs-wrapper .tabs .tab-link").on('click', function() {
    if($(this).data('target')) {
      $(".tabs-wrapper .tabs .tab-link").removeClass("active");
      $(this).addClass("active");

      var target = $(this).data('target');
      var tab_height = r;

      if (!$(".tabs-wrapper .tabs").hasClass("tabs-sticky")) {
        tab_height = $('.tabs-wrapper .tabs-wrapper').height();
      }

      $(".tab-section").hide();
      $("#"+ target).fadeIn();
      if ($(window).width() <= 991){
        $("html, body").animate({
          scrollTop: ($("#"+ target).offset().top)
        }, 1e3);
      }else{
        $("html, body").animate({
          scrollTop: ($("#"+ target).offset().top - (tab_height ))
        }, 1e3);
      }

    }

  });
  $('.scroll.product-btn').on('click', function() {
    var target = $(this).data('target');
    var tab_height = r;

    if (!$(".tabs-wrapper .tabs").hasClass("tabs-sticky")) {
      tab_height = $('.tabs-wrapper .tabs-wrapper').height();
    }

    $(".tab-section").hide();
    $("#"+ target).fadeIn();
    if ($(window).width() <= 991){
      $("html, body").animate({
        scrollTop: ($("#"+ target).offset().top)
      }, 1e3);
    }else{
      $("html, body").animate({
        scrollTop: ($("#"+ target).offset().top - (tab_height ))
      }, 1e3);
    }
  });

  $(function() {
    $('.scrollup').click(function() {
      $("html, body").animate({
        scrollTop:0
      },1000);
    })
  })

  $(window).scroll(function() {
    if ($(this).scrollTop()>200) {
      $('.scrollup').fadeIn();
    }
    else {
      $('.scrollup').fadeOut();
    }
  });


});